import { ObjectMapper } from 'json-object-mapper';
import { IModel } from 'services/models/IModel';
import { Model } from 'services/models/model';

export class FormSubmissionAnswerModel extends Model implements IModel<FormSubmissionAnswerModel> {
  public id: string = '';
  public value: string = '';
  public formItemId: string = '';
  public formSubmissionId: string = '';
  public formItemOptionIds: string[] = [];

  static create(input: any): FormSubmissionAnswerModel {
    return ObjectMapper.deserialize<FormSubmissionAnswerModel>(FormSubmissionAnswerModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
